<app-chart-wrapper [title]="'Interest Income vs. Interest Expense'" (fullscreen)="hideFilters = $event">
    <app-chart-filter filter [form]="interestIncomeForm" [formControls]="interestIncomeFormControls" *ngIf="!hideFilters" (filter)="filterInterestIncome($event)"></app-chart-filter>
    <app-grouped-column-chart chart></app-grouped-column-chart>
</app-chart-wrapper>